import BaseProxy from "../../base-proxy";

export default {
  async createPaymentToken(input = {}) {
    let baseProxy = new BaseProxy();
    if (!input.authToken) {
      return {};
    }
    let backendUrl = await baseProxy.getBackendUrl();
    let endpointUrl = `${backendUrl}/v2/payment-tokens/create/`;
    let company = await baseProxy.postAuthenticatedData(endpointUrl, input.authToken);
    return company;
  },
};
